/* eslint-disable import-x/no-default-export */
import Chance from 'chance';

const chance = new Chance();

export default () => ({
  __typename: chance.bool({ likelihood: 10 })
    ? 'UnconfirmedDataCompleted'
    : 'UnconfirmedDataPending',
});
